import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { Button } from '@/components/ui/button';
    import { ChevronLeft, ChevronRight } from 'lucide-vue-next';
    import {
        PaginationEllipsis,
        PaginationList,
        PaginationListItem,
        PaginationNext,
        PaginationPrev,
        PaginationRoot,
    } from 'reka-ui';
    import { watch } from 'vue';
    import type { Table } from '@tanstack/vue-table';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DataTablePagination',
  props: {
    table: {},
    totalRecords: {}
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PaginationRoot), {
    total: _ctx.totalRecords,
    "sibling-count": 1,
    "items-per-page": _ctx.table.getState().pagination.pageSize,
    "onUpdate:page": _cache[0] || (_cache[0] = ($event: any) => (_ctx.table.setPageIndex($event - 1))),
    "show-edges": "",
    page: _ctx.table.getState().pagination.pageIndex + 1
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(PaginationList), { class: "border-input flex items-center rounded-md border shadow-xs [&>button]:rounded-none [&>button]:border-r [&>button]:last:border-r-0" }, {
        default: _withCtx(({ items }) => [
          _createVNode(_unref(PaginationPrev), { "as-child": "" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                variant: "ghost_primary",
                size: "icon"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ChevronLeft))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (page, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (page.type === 'page')
                ? (_openBlock(), _createBlock(_unref(PaginationListItem), {
                    key: index,
                    class: "data-[selected]:bg-background! hidden sm:flex",
                    value: page.value,
                    "as-child": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Button), {
                        variant: "ghost_primary",
                        size: "icon"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(page.value), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                : (_openBlock(), _createBlock(_unref(PaginationEllipsis), {
                    key: page.type,
                    class: "hidden sm:flex",
                    index: index,
                    "as-child": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Button), {
                        variant: "ghost_primary",
                        size: "icon",
                        class: "hover:text-foreground cursor-default"
                      }, {
                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                          _createTextVNode(" … ")
                        ])),
                        _: 1,
                        __: [1]
                      })
                    ]),
                    _: 2
                  }, 1032, ["index"]))
            ], 64))
          }), 256)),
          _createVNode(_unref(PaginationNext), { "as-child": "" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                variant: "ghost_primary",
                size: "icon"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ChevronRight))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["total", "items-per-page", "page"]))
}
}

})